import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CardHeader,
  Media,
  Input,
  Badge,
} from "reactstrap";
import {
  faAngleDown,
  faAngleUp,
  faCheck,
  faCog,
  faHome,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  ButtonGroup,
  Breadcrumb,
} from "@themesberg/react-bootstrap";

import { getProjects } from "../../../services/clientProjectService";
import SpinDiv from "../../components/SpinDiv";
import moment from "moment";
import { throttle,debounce } from "./debounce";
import 'antd/dist/antd.css';
import { Pagination } from 'antd';
import EditProject from "./EditProject";
import { Progress } from 'antd';

export class ProjectIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      projects:[],
      total: 0,

    

    };
    this.searchDebounced = debounce(this.searchProjects, 500);
    this.searchThrottled = throttle(this.searchProjects, 500);
  }

  componentDidMount() {
    this.searchProjects();
  }

  

  searchProjects = () => {
    const { page, rows, search, projects } = this.state;
    this.setState({ loading: true });
    getProjects({ page, rows, search, projects }).then(

      (res) => {
        this.setState({
          projects: res.projects.data,
          total:res.projects.total,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

 

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  onPage = async (page,rows) => {
    await this.setState({page,rows});
    await this.getProjects();
  }
  
  handleSearch = event => {
    this.setState({ search: event.target.value }, () => {
      if(this.state.search < 5){
        this.searchThrottled(this.state.search);
      }else{
        this.searchDebounced(this.state.search);
      }
    
    });
  };
  
  toggleDeleteProject=(deleteProject)=>{
    this.setState({deleteProject});
  }

  toggleEditProject = (project) => {
    this.setState({ project});
    this.searchProjects();
   
  };
  toggleCloseProject=(project)=>{
    this.setState({ project: !this.state.project });
    this.searchProjects();
  }

 

  toggleAddProject = () => {
    this.setState({ addProject: !this.state.addProject });
    this.searchProjects();
  }

  
  



  formatCurrency(x) {
    if (x !== null && x !== '0' && x !== undefined) {
        const parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${parts.join(".")}`;
    }

}




  

  render() {
    const { projects,  project, deleteProject, total, title, progress, page, rows, search, loading,addProject, editProject } = this.state;
    
    return (
      <>
       
        
       

        {project && (
          <EditProject
            saved={this.searchProjects}
            project={project}
            toggle={this.toggleCloseProject}
          />
        )}

      
      
       
        {loading && <SpinDiv text={"Loading..."} />}

        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#users">Projects</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="btn-toolbar mb-2 mb-md-0">
                {/* <ButtonGroup>
                  <Button variant="outline-primary" size="sm" onClick={() => this.toggleAddProject()}>
                    Create Project
                  </Button>
                </ButtonGroup> */}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="8">
          <h5 className="mb-0">Projects
          <span style={{color: '#aaa', fontSize: 14, fontWeight: 'normal'}}> ({total})</span></h5>
          </Col>
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                autoFocus
                id="show"
                value={search}
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                onChange={this.handleSearch}
                
              />
            </div>
          </Col>
        </Row>

        <Card border="light" className="shadow-sm mb-4">
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  {/* <th className="border-0">Project</th> */}
                  <th className="border-0">Title</th>
                  <th className="border-0">Client</th>
                  <th className="border-0">Budget</th>
                  <th className="border-0">Progress</th>
                  <th className="border-0">Start Date</th>
                  <th className="border-0">End Date</th>
                  {/* <th className="border-0">actions</th> */}
                </tr>
              </thead>
              <tbody>
                
                {projects.map((project, key) => {
               
                  return (
                    <tr >
                     
                      <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{project.title}</span>
                      </td>
                      <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{project.client_name}</span>
                      </td>
                      <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>
                          {project.currency !== null ? project.currency :'#'}{this.formatCurrency(project.cost)}</span>
                      </td>
                      <td>
                        <Progress percent={project.progress} status={project.progress < 50 ? 'exception':''} />
                      </td>
                      <td>{moment(project.start_date).format('MMM D, YYYY')}</td>
                      <td>{project.deadline !== null ? moment(project.deadline).format('MMM D, YYYY'): 'Nil'}</td>
                    
                      {/* <td>
                        
                        <ButtonGroup>
                          <Button variant="outline-primary" 
                          style={{fontWeight:"bold",textTransform:"capitalize"}} 
                          onClick={() => this.toggleEditProject(project)} size="sm">view</Button>
                          
                        </ButtonGroup>
                      </td> */}

                      
                      
                    </tr>
                  );
                })}
              </tbody>
             
            </Table>
            <Row>
              <Col md={12} style={{fontWeight:"bold",paddingTop:3}}>
              {projects.length<1&&
                <div style={{color: '#ccc', alignSelf: 'center', padding: 10, fontSize: 13}}>
                  <i className="fa fa-ban" style={{marginRight: 5}}/>
                  No Projects yet
                </div>}
              {projects.length > 0 && <Pagination
                  total={total}
                  showTotal={total => `${total} Projects`}
                  onChange={this.onPage}
                  pageSize={rows}
                  current={page}
                />}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default ProjectIndex;
